<template>
  <div>
    <el-form ref="form" :model="formData" :rules="rules">
      <el-row :gutter="20">
        <el-col
          :xs="{ span: 20 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 12 }"
        >
          <el-form-item
            :label="$l('form_label_attr_name_cn') || '面料属性值中文'"
            prop="fabricAttrValueCn"
          >
            <el-input
              v-model="formData.fabricAttrValueCn"
              clearable
              :disabled="disabled"
              size="medium"
              :placeholder="
                $l('form_label_attr_name_cn_placeholder') || '请输入属性值'
              "
              maxlength="200"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col
          :xs="{ span: 20 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 12 }"
        >
          <el-form-item
            :label="$l('form_label_category') || '面料类别'"
            prop="fabricCategoryCode"
          >
            <el-cascader
              v-model="formData.fabricCategoryCode"
              :options="categoryOptions"
              :show-all-levels="false"
              :props="{
                label: 'fabricCategoryName',
                value: 'fabricCategoryCode',
              }"
              style="width: 100%"
              size="medium"
              :placeholder="
                $l('form_label_category_placeholder') || '请选择面料类别'
              "
              :disabled="disabled"
              filterable
              clearable
            ></el-cascader>
          </el-form-item>
        </el-col>
        <el-col
          :xs="{ span: 20 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 12 }"
        >
          <el-form-item
            :label="$l('form_label_attr_name_en') || '面料属性值英文'"
            prop="fabircAttrValueEn"
          >
            <el-input
              v-model="formData.fabircAttrValueEn"
              clearable
              :disabled="disabled"
              size="medium"
              maxlength="200"
              :placeholder="
                $l('form_label_attr_name_en_placeholder') || '请输入属性值英文'
              "
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col
          :xs="{ span: 20 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 12 }"
        >
          <el-form-item
            :label="$l('form_label_type') || '属性类型'"
            prop="fabricAttrTypeCn"
          >
            <el-input
              v-model="formData.fabricAttrTypeCn"
              clearable
              disabled
              size="medium"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col
          :xs="{ span: 20 }"
          :sm="{ span: 12 }"
          :md="{ span: 12 }"
          :lg="{ span: 12 }"
        >
          <el-form-item
            :label="$l('form_label_status') || '状态'"
            prop="fabricAttrStatus"
          >
            <el-radio-group
              style="width: 100%"
              size="medium"
              disabled
              v-model="formData.fabricAttrStatus"
            >
              <el-radio label="Y">{{
                $l("form_radio_available") || "可用"
              }}</el-radio>
              <el-radio label="N">{{
                $l("form_radio_unavailable") || "不可用"
              }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col v-if="formData.fabricAttrCode">
          <div style="font-size: 14px; color: #606266">
            <span
              >Create：{{ formData.createdBy }} at
              {{ formData.createdTime }}</span
            >
            <el-divider direction="vertical"></el-divider>
            <span
              >Modify：{{ formData.updatedBy }} at
              {{ formData.updatedTime }}</span
            >
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
export default {
  props: {
    params: {
      default: null,
      type: Object,
    },
  },
  data() {
    return {
      disabled: false,
      categoryOptions: [],
      formData: {
        fabricAttrCode: "",
        fabricCategoryCode: "", // 面料类别编码,通用类别使用common
        fabricAttrTypeCn: "", // 面料属性类型中文
        fabricAttrTypeEn: "", // 面料属性类型英文(存类型内码值)
        fabricAttrValueCn: "", // 面料属性值中文
        fabircAttrValueEn: "", // 面料属性值英文
        fabricAttrStatus: "Y", // 面料属性值状态：Y-可用,N-不可用
        createdTime: "",
        createdBy: "",
        updatedTime: "",
        updatedBy: "",
      },
      rules: {
        fabricAttrTypeCn: [
          {
            required: true,
            message: this.$l("form_rule_message_name_type") || "请填写属性类型",
            trigger: "input",
          },
        ],
      },
    };
  },
  methods: {
    formLoad(ref, val = "") {
      this.init();
      this.loadCategoryData();
      if (ref !== "add") {
        this.$api
          .masterFabricAttributesDetailApi({ fabricAttrCode: val })
          .then((res) => {
            this.formData = res.body;
          });
        // 控制组件不可编辑
        if (ref === "detail") {
          this.disabled = true;
        }
      } else {
        this.formData.fabricAttrTypeCn = this.params.fabricAttrTypeCn;
        this.formData.fabricAttrTypeEn = this.params.fabricAttrTypeEn;
      }
    },
    loadCategoryData() {
      this.$api.masterFabricCategory_tree().then((res) => {
        if (res.body.data) {
          this.categoryOptions = res.body.data;
        }
        this.categoryOptions.push({
          children: null,
          fabricCategoryCode: "common",
          fabricCategoryName: "通用分类(Common)",
          level: "1",
        });
      });
    },
    changeListFiled(list) {
      let newList = [];
      if (list && list.length > 0) {
        list.forEach((t) => {
          let newItem = {
            fabricCategoryName: t.fabricCategoryName,
            fabricCategoryCode: t.fabricCategoryCode,
            level: t.levelNo,
            children: t.children,
          };
          newList.push(newItem);
          if (t.children && t.children.length > 0) {
            newItem.children = this.changeListFiled(t.children);
          }
        });
      }
      return newList;
    },
    save() {
      // 校验表单正确性
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (Array.isArray(this.formData.fabricCategoryCode)) {
            this.formData.fabricCategoryCode = this.formData.fabricCategoryCode.pop();
          }
          this.$api.masterFabricAttributesSaveApi(this.formData).then(() => {
            this.$message.success(this.$l("INDEX.tips_save_ok") || "保存成功");
            // 通知父组件保存成功
            this.$emit("success");
          });
        } else {
          return false;
        }
      });
    },
    init() {
      this.disabled = false;
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
      // this.categoryOptions = [];
      this.formData = {
        fabricAttrCode: "",
        fabricCategoryCode: "",
        fabricAttrTypeCn: "",
        fabricAttrTypeEn: "",
        fabricAttrValueCn: "",
        fabircAttrValueEn: "",
        fabricAttrStatus: "Y",
        createdTime: "",
        createdBy: "",
        updatedTime: "",
        updatedBy: "",
      };
    },
  },
};
</script>
<style scoped>
</style>